// Bootstrap file - delays loading to avoid Module Federation eager consumption error
import('./bootstrap').catch((err) =>
  console.error('Failed to load bootstrap:', err)
);
